import { Button } from '@cocoonspace/ui/components/button'
import { useLingui } from '@lingui/react/macro'

export const ExtraSelectButton = ({ onClick }: { onClick?: () => void }) => {
	const { t } = useLingui()

	return (
		<Button
			className='md:ml-auto'
			onClick={onClick}
		>
			{t`Sélectionner`}
		</Button>
	)
}

export const ExtraUpdateButton = ({ onClick }: { onClick?: () => void }) => {
	const { t } = useLingui()

	return (
		<Button
			className='md:ml-auto'
			onClick={onClick}
			variant='outline'
		>
			{t`Modifier`}
		</Button>
	)
}
